import React from 'react'
import rollbar from '@src/util/rollbar'

class ErrorBoundary extends React.Component<any, { hasError: boolean }> {
  constructor(props: any) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(_error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: any) {
    // You can also log the error to an error reporting service
    rollbar.error(error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-screen p-4 bg-gray-50">
          <h1 className="text-2xl font-bold text-wove-error mb-4">Something went wrong</h1>
          <p className="text-wove-grey text-center mb-8">
            We're sorry, but something went wrong. Please try refreshing the page or contact support
            if the problem persists.
          </p>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
